// extracted by mini-css-extract-plugin
export var chevron = "_g4-2";
export var dropdownItems = "_g4-0";
export var item = "_g4-1";